import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@program-suite/ui';
import { ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PolicyEndorsementsService } from '@program-suite/data-common';

export interface DownloadAIAppModalData {
  businessName?: string;
  policyNumber?: string;
  typeOfEndorsement?: string;
  policyChangeGuid: string;
}

@Component({
  selector: 'lib-download-ai-application',
  imports: [CommonModule, ModalLayoutComponent, ButtonComponent],
  templateUrl: './download-ai-application.component.html',
  styleUrl: './download-ai-application.component.scss',
})
export class DownloadAIApplicationComponent {
  data = inject(MAT_DIALOG_DATA) as DownloadAIAppModalData;
  dialogRef = inject(MatDialogRef<DownloadAIApplicationComponent>);
  policyChangeService = inject(PolicyEndorsementsService);

  downloadApplication() {
    this.policyChangeService.downloadApplication(this.data.policyChangeGuid).then(() => {});
  }
}
